import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
import axios from "axios";
import upLoad from '@/assets/img/screenshoot_upload.png';
import CONFIG from "@/assets/js/config.js";

export default{
  name: "SettingPage",

  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      isLoading: false,
      disabled: false,
      settings: {
        teacher_chat_approval: false,
        chat_file_upload_enabled: false,
        send_notice_notifications: false,
        use_facebook_page: false,
        signature: upLoad,
        facebook_integration : false,
        currency: null,
        report_card_grading: null,
        school_start_time: null,
        school_end_time: null,
        teacher_attendance_qr: null,
        client_type: null,
        payment_slip_size: 0
      },
      reportCardGrading: [],
      paymentSlipSize: CONFIG.PAYMENT_SLIP_SIZE
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },

  methods: {
    getSetting() {
      this.isLoading = true;
      axios
        .get("/setting/" + this.$store.state.user.campus_id)
        .then((response) => {
          this.settings.teacher_chat_approval = response.data.teacher_chat_approval == 1 ? true : false;
          this.settings.chat_file_upload_enabled = response.data.chat_file_upload_enabled == 1 ? true : false;
          this.settings.send_notice_notifications = response.data.send_notice_notifications == 1 ? true : false;
          this.settings.facebook_integration = response.data.facebook_integration == 1 ? true : false;
          this.settings.use_facebook_page = response.data.use_facebook_page == 1 ? true : false;
          this.settings.signature = response.data.signature == null ? upLoad : response.data.signature;
          this.settings.currency = response.data.currency || null;
          this.settings.report_card_grading = response.data.report_card_grading ?? null;
          this.settings.school_start_time = response.data.school_start_time ?? null;
          this.settings.school_end_time = response.data.school_end_time ?? null;
          this.settings.teacher_attendance_qr = response.data.teacher_attendance_qr ?? null;
          this.settings.client_type = CONFIG.CLIENT_TYPE[response.data.client_type] || null;
          this.settings.payment_slip_size = response.data.payment_slip_size ?? 0;
          this.getReportCardGrading(this.settings.report_card_grading);
          this.isLoading = false;
        })
        .catch((error) => {
            if (error.response && error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
            }
        });
    },

    printPaymentSlipSize(value) {
      const size = this.paymentSlipSize.find(s => s.id == value);
      return size ? size.text : "Default Size"
    },

    async getReportCardGrading(value) {
      try {
        const response = await axios.get('setting/report-card-grading');
        if (response) {
          this.reportCardGrading = Object.values(response.data).find(i => i.value == value);
        }
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
      }
    },

    downloadAttendanceQR() {
      this.isLoading = true;
      axios.get("/setting/download/attendance-qr", {
        params: {
          campus_id: this.$store.state.user.campus_id,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        responseType: 'blob' 
      })
      .then(qrResponse => {
        if (qrResponse.status == 200) {
          const url = window.URL.createObjectURL(new Blob([qrResponse.data]));
          const link = document.createElement('a');
          link.href = url;
          var currentDate = new Date();
          const fileName = `teacher_attendance_qr_${currentDate.getFullYear()}${(currentDate.getMonth() + 1).toString().padStart(2, '0')}${currentDate.getDate().toString().padStart(2, '0')}.pdf`;          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          this.isLoading = false;
        }
      })
      .catch(error => {
        if (error.qrResponse.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      })   
    }
  },

  mounted() {
    this.getSetting();
  }
}
